// Constants for CUPRA IDK integration
const CUPRAIDK_BASE_URL = "https://identity.vwgroup.io/oidc/v1/authorize";
const CUPRAIDK_CLIENT_ID = "eadee25e-6a76-482d-9ea3-9ee330241e29@apps_vw-dilab_com";
const CUPRAIDK_CALLBACK_URL = "https://ecommerce.prod.cupramarketplace.seat.cloud.vwgroup.com/cupra-middleware/cupraid-callback";

// This script modifies the login button to redirect to the CUPRA IDK authorization URL
const changeLoginUrlToIdk = (e) => {
    e.preventDefault();
    window.location.href= `${CUPRAIDK_BASE_URL}?client_id=${CUPRAIDK_CLIENT_ID}&response_type=code&scope=openid%20profile%20email%20nickname&redirect_uri=${CUPRAIDK_CALLBACK_URL}`;
}

// Add event listener to the login button
let loginButton = document.querySelector('form#customer_login button');
if (loginButton != null) {
    loginButton.addEventListener('click', changeLoginUrlToIdk, false);
}

// Add event listener to the create account button
let createAccountButton = document.querySelector('form#create_customer button');
if (createAccountButton != null) {
    createAccountButton.addEventListener('click', changeLoginUrlToIdk, false);
}